import React from 'react';
import { Play } from 'lucide-react';
export function BridgePage() {
  const AFFILIATE_LINK = "https://citrusburn.com/?&shield=963d1n0-if0h8w5xnd4tx39gti";

  // 🔥 TRACKING CLICK PARA META
  const trackAffiliateClick = () => {
    if ((window as any).fbq) {
      (window as any).fbq('track', 'ViewContent');
    }
  };
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-100 selection:text-red-900" data-id="element-2">
      <div className="mx-auto max-w-2xl px-6 py-12 md:py-16" data-id="element-3">
        {/* Headline */}
        <h1 className="mb-8 text-center text-3xl font-bold leading-tight tracking-tight text-black md:text-4xl lg:text-5xl" data-id="element-4">
          This explains why your body refuses to burn fat… even when you diet
        </h1>

        {/* Video/Image Container */}
       <a href={AFFILIATE_LINK} target="_blank" rel="nofollow sponsored noopener" onClick={trackAffiliateClick} className="group relative mb-10 block" aria-label="Watch video explanation" data-id="element-5">

          <div className="aspect-video w-full relative" data-id="element-6">
            <img src="https://cdn.magicpatterns.com/uploads/uU422FzftqmWotxVtrwffP/chacon3110_Human_body_silhouette_abdominal_area_highlighted_w_337ad030-437e-4a79-86c8-08a3fbb34e8d_0.png" alt="Silhouette of human body with highlighted abdominal area showing metabolism activity" className="h-full w-full object-cover" data-id="element-7" />

            {/* Dark Overlay for better contrast */}
            <div className="absolute inset-0 bg-black/10 transition-colors group-hover:bg-black/20" data-id="element-8" />

            {/* Play Button Overlay */}
            <div className="absolute left-1/2 top-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-red-600 shadow-lg ring-4 ring-white/30 transition-transform group-hover:scale-110 md:h-24 md:w-24" data-id="element-9">
              <Play className="ml-2 h-10 w-10 fill-white text-white md:h-12 md:w-12" data-id="element-10" />
            </div>
          </div>
        </a>

      {/* Body Copy */}
      <article className="prose prose-lg max-w-none text-gray-700" data-id="element-11">
  <p data-id="element-12">Most people think the problem is food.</p>

  <p data-id="element-13">
    They try dieting. They try keto. They eat less. They walk more.
  </p>

  <p data-id="element-14">
    And still… the fat doesn’t go away like it should.
  </p>

  <p data-id="element-15">
    Because the problem is rarely the diet.
  </p>

  <p data-id="element-16">
    It’s something called metabolic slowdown.
  </p>

  <p data-id="element-17">
    When this happens, your body switches into a protective mode.
    You burn less energy, feel more tired, and your body holds onto fat no matter what you try.
  </p>

  <p data-id="element-18">
    Until this is addressed, nothing works the way it should.
  </p>

  <p data-id="element-19">
    This short video explains why this happens and what type of formula was designed specifically
    to support metabolism before trying to burn fat.
  </p>
      </article>


    {/* CTA Button */}
      <div className="mb-12 text-center" data-id="element-20">
  <a href={AFFILIATE_LINK} target="_blank" rel="nofollow sponsored noopener" onClick={trackAffiliateClick} className="inline-flex items-center justify-center w-full sm:w-auto rounded-xl bg-green-500 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-green-600 transition" data-id="element-21">
    Watch the short video
  </a>
      </div>

        {/* Disclosure */}
        <footer className="border-t border-gray-100 pt-8 text-center" data-id="element-22">
          <p className="text-xs text-gray-400" data-id="element-23">
            Disclosure: This site contains affiliate links. We may receive a
            commission if you make a purchase through our links, at no
            additional cost to you. The content on this page is for
            informational purposes only and does not constitute medical advice.
          </p>
        </footer>
      </div>
    </main>;
}